module.exports = __webpack_public_path__ + "img/student_4.5317fce4.png";